<template>
  <div class="apc-container">
    <div class="apc-header">
      {{ title }}
    </div>
    <div class="apc-main">
      <slot name="default" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="postcss" scoped>
.apc-container {
  /* Base */
  @apply tw-bg-[#FAFAFA] tw-min-h-[56px] tw-rounded-[10px] tw-flex tw-flex-row tw-items-start tw-border tw-border-t-8 tw-gap-2;

  /* Desktop */
  @apply lg:tw-h-[72px] lg:tw-gap-2;
}

.apc-header {
  /* Base */
  @apply tw-ml-2 tw-mr-1 tw-my-1 tw-flex-none tw-w-[56px] tw-font-semibold tw-text-sm tw-leading-4 tw-text-[#2F2B31];
  font-family: 'Exo 2', sans-serif;

  /* Desktop */
  @apply lg:tw-w-[90px] lg:tw-text-base;
}

.apc-main {
  /* Base */
  @apply tw-mr-2 tw-my-1 tw-flex-1 tw-font-light tw-text-xs tw-leading-[14px] tw-text-black;
  font-family: 'Exo 2', sans-serif;
  @apply lg:tw-text-sm;
}
</style>
